"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsAccount = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Box_1 = tslib_1.__importDefault(require("@material-ui/core/Box"));
var index_1 = require("../../../index");
var handleEditorAccount = function (item) {
    console.log(item);
};
var handleOpenDualAuthentication = function (item) {
    alert(item);
};
function UserSettingsAccount() {
    return (react_1.default.createElement(index_1.SettingContainer, null,
        react_1.default.createElement(index_1.DefaultTitle, null, "\u6211\u7684\u8D26\u53F7"),
        react_1.default.createElement(index_1.SettingUserInfoView, { url: "http://img0.imgtn.bdimg.com/it/u=2897236439,4117628495&fm=26&gp=0.jpg", text: "码萌", code: "#4753", desc: "guokaigdg@gmail.com", onClick: handleEditorAccount }),
        react_1.default.createElement(Box_1.default, { height: 60 }),
        react_1.default.createElement(index_1.DefaultTitle, null, "\u53CC\u91CD\u8BA4\u8BC1"),
        react_1.default.createElement(index_1.SmallTitle, null, "\u4F7F\u7528\u989D\u5916\u7684\u5B89\u5168\u624B\u6BB5\u4FDD\u62A4\u60A8\u7684 Discord \u5E10\u6237\u3002\u4E00\u65E6\u914D\u7F6E\u5B8C\u6BD5\uFF0C\u6BCF\u6B21\u767B\u9646\u65F6\u60A8 \u90FD\u9700\u8981\u540C\u65F6\u8F93\u5165\u5BC6\u7801\u548C\u624B\u673A\u5E94\u7528\u4E0A\u751F\u6210\u7684\u53CC\u91CD\u8BA4\u8BC1\u4EE3\u7801\u3002"),
        react_1.default.createElement(Box_1.default, { height: 20 }),
        react_1.default.createElement(index_1.SettingPrimaryButton, { onClick: handleOpenDualAuthentication }, "\u5F00\u542F\u53CC\u91CD\u8BA4\u8BC1")));
}
exports.UserSettingsAccount = UserSettingsAccount;
//# sourceMappingURL=UserSettingsAccount.js.map